export const sendDataLayerEvent = (eventName, props) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...props
  });
};

export const addHeapEventProperties = properties =>
  sendDataLayerEvent('addHeapEventProperties', {heapGlobalEventProperties: properties});

export const trackHeapEvent = (heapEventName, heapEventProperties) =>
  sendDataLayerEvent('trackHeapEvent', {heapEventName, heapEventProperties});

export const throwRollbarError = (error) => {
  if (window?.Rollbar) {
    window.Rollbar.error(error);
  } else {
    console.error(error);
  }
};
